module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-row vehicle_detail"
  }, [_c('ul', [_c('li', [_c('span', [_vm._v("车辆ID：")]), _c('em', [_vm._v(_vm._s(_vm.carInfo.vehicleId))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("服务卡号：")]), _c('em', [_vm._v(_vm._s(_vm.carInfo.vehicleAccount))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("服务起始日：")]), _c('em', [_vm._v(_vm._s(_vm.startTime))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("服务结束日：")]), _c('em', [_vm._v(_vm._s(_vm.endTime))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("车型车系：")]), _c('em', [_vm._v(_vm._s(_vm.carInfo.modelName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("车牌号：")]), _c('em', [_vm._v(_vm._s(_vm.carInfo.plateNumber))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("车辆登记日期：")]), _c('em', [_vm._v(_vm._s(_vm.saleTime))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("车主：")]), _c('em', [_vm._v(_vm._s(_vm.carInfo.vehicleOwnerName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("联系方式：")]), _c('em', [_vm._v(_vm._s(_vm.carInfo.phone))])])])]), _vm._v(" "), (_vm.permission.indexOf('monitorVehicle_alarmPanelCarDetail') == -1) ? _c('div', {
    staticClass: "track_bottom_btn",
    on: {
      "click": _vm.addTab
    }
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('a', {
    staticClass: "ico_02"
  }, [_vm._v("更多详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37ff2b08","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehiclemonitor/menumaptabs/VehicleDetail.vue
// module id = 1475
// module chunks = 0